import React from "react";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import FormControl from "react-bootstrap/lib/FormControl";
import FormGroup from "react-bootstrap/lib/FormGroup";

import "./PasswordResetForm.scss";

interface Props {
  onPasswordChanged: (event: React.ChangeEvent<FormControl.FormControlProps>) => void;
  onPasswordConfirmationChanged: (event: React.ChangeEvent<FormControl.FormControlProps>) => void;
  password: string;
  passwordConfirmation: string;
}

const PasswordResetForm: React.FC<Props> = props => {
  const {
    onPasswordChanged,
    onPasswordConfirmationChanged,
    password,
    passwordConfirmation,
  } = props;

  return (
    <>
      <FormGroup controlId="password">
        <ControlLabel>Password *</ControlLabel>
        <FormControl
          name="spree_user[password]"
          type="password"
          value={password}
          onChange={onPasswordChanged}
        />
      </FormGroup>

      <FormGroup controlId="passwordConfirmation">
        <ControlLabel>Password Confirmation *</ControlLabel>
        <FormControl
          name="spree_user[password_confirmation]"
          type="password"
          value={passwordConfirmation}
          onChange={onPasswordConfirmationChanged}
        />
      </FormGroup>
    </>
  );
};

export { PasswordResetForm };
